import type { FpSpMessageType, SpMessageSubject } from '../types';

export type MessageTypeOption = { value: FpSpMessageType; label: string };

export type SpMessageSubjectOption = { value: SpMessageSubject; label: string };

/**
 * SP compose-time subject catalog (feature 102). Shown to a SERVICE_PROVIDER
 * sender before the first message of any conversation, regardless of the
 * recipient's role.
 */
export const SP_MESSAGE_SUBJECT_OPTIONS: SpMessageSubjectOption[] = [
  { value: 'NETWORKING', label: 'Networking' },
  { value: 'DISCUSSING_SHARED_CLIENT', label: 'Discussing a shared client' },
  { value: 'INQUIRING_ABOUT_SERVICES', label: 'Asking about their services' },
  { value: 'INTRODUCING_MYSELF', label: 'Introducing myself' },
  { value: 'MISCELLANEOUS', label: 'Something else' },
];

/**
 * Existing FA→SP first-message intent catalog (spec ticket 08 §3). Shared by
 * the pre-chat intent modal and its chat-surface fallback so both surfaces
 * show identical, neutral wording — no option is worded to steer toward
 * `SEEKING_CARE_FOR_SPECIFIC_CLIENT` over the others.
 */
export const MESSAGE_TYPE_OPTIONS: MessageTypeOption[] = [
  { value: 'SEEKING_CARE_FOR_SPECIFIC_CLIENT', label: 'Seeking care for a specific client' },
  { value: 'NETWORKING', label: 'Networking' },
  { value: 'INQUIRING_ABOUT_SERVICE_OFFERINGS', label: 'Inquiring about service offerings' },
  { value: 'MISCELLANEOUS', label: 'Something else' },
];
